export default __webpack_public_path__ + "static/media/howard.b7402144.png";